import { Map } from 'immutable';
import actions from './actions';

const initState = new Map({
  applications: [],
  applicationCount: 0,
  // { [projectId]: selectionLevels[] } so cross-project rows can render custom column names.
  // Empty unless the dynamic_selection_levels flag is on; accumulated across pagination.
  selectionLevelsByProject: {},
  loading: true,
  filters: new Map({
    candidateName: '',
    tags: [],
    projects: [],
    limit: 50,
    offset: 0,
  }),
  availableFilters: new Map({}),
});

export default function allApplicationsReducer(state = initState, action) {
  switch (action.type) {
    case actions.ALL_APPLICATIONS_FETCH_START:
      return state.set('loading', true);

    case actions.ALL_APPLICATIONS_FILTERS_FETCH_DONE: {
      const { project: projects } = action.payload[0].data.projects;
      const { projectFilters: tags } = action.payload[1].data;
      return state
        .setIn(['availableFilters', 'projects'], projects)
        .setIn(['availableFilters', 'tags'], tags);
    }

    case actions.ALL_APPLICATIONS_RESET_FILTER:
      return state.set('filters', initState.get('filters')).set('loading', true);

    case actions.ALL_APPLICATIONS_SET_FILTER:
      return state
        .setIn(['filters', action.payload.field], action.payload.value)
        .set('loading', true);

    case actions.ALL_APPLICATIONS_FETCH_DONE:
      return state
        .set('applications', action.payload.applications)
        .set('applicationCount', action.payload.count)
        .set('selectionLevelsByProject', action.payload.selectionLevelsByProject || {})
        .set('loading', false);

    case actions.SET_ALL_APPLICATIONS:
      // Merge so paginated batches add their projects without dropping earlier ones.
      return state
        .set('applications', action.payload.applications)
        .set('selectionLevelsByProject', {
          ...state.get('selectionLevelsByProject'),
          ...(action.payload.selectionLevelsByProject || {}),
        });
    case 'LOGOUT':
      return initState;
    default:
      return state;
  }
}
